module.exports = __webpack_public_path__ + "static/media/hsf.ea034cc0.webp";